const TRANSLATION_AR = {
	// confirmDeletion: "Confirm deletion",
	// deleteTheTemplateFor: "Delete the template for",
	// cancel: "Cancel",
	// delete: "Delete",
	// createContent: "Create content",
	// askAQuestion: "Ask a question",
	// createAPoll: "Create a poll",
	// createAPost: "Create a post",
	// orChooseFromTemplatesBelow: "or choose from templates below",
	// on: "On",
	// never: "Never",
	// chooseTemplate: "Choose template",
	// thereAreNoTemplatesCreated: "There are no templates created",
	howAreYouToday: 'How are you today?',
	selectEmotion: 'Select emotion',
	question: 'Question',
	// genderSelection: "Gender selection",
	// all: "All",
	// male: "Male",
	// female: "Female",
	// settings: "Settings",
	// support: "Support",
	privacyPolicy: 'Privacy policy',
	// about: "About",
	dayReview: 'Day review',
	dailyReflection: 'Daily reflection',
	// youLiked: "You liked",
	like: 'Like',
	// edit: "Edit",
	// answered: "Answered",
	showLess: 'Show Less',
	showMore: 'Show More',
	search: 'Search',

	// targetGroup: "Target group",
	// quickAction: "Quick action",
	// select: "Select",
	// selectByGroup: "Select by group",
	// selectSchoolYearsThatYouLikeToTarget: "Select school years that you like to target",
	years: 'Years',
	year: 'Year',
	// selectClassesThatYouLikeToTarget: "Select classes that you like to target",
	classes: 'Classes',
	class: 'Class',
	// selectACustomListThatYouLikeToTarget: "Select a custom list that you like to target",
	custom: 'Custom',
	// selectTeachersYouWouldLikeToTarget: "Select teachers you would like to target",
	staff: 'Staff',
	// selectYears: "Select years",
	// selectClasses: "Select classes",
	// selectFromMyStudents: "Select from my students",
	// multipleClasses: "Multiple classes",
	// multipleYears: "Multiple years",
	allStudents: 'All students',
	// done: "Done",
	// waitForTeachersToFeedYouWithSomeNewInformations: "Wait for teachers to feed you with some new informations",
	// feedIsEmpty: "Feed is empty",
	// thereIsNoFeedForThisSearch: "There is no feed for this search",
	// createNewPostsForYourStudentsAndHereIsAShortcutForYou: "Create new posts for your students. Here is a shortcut for you.",
	// waitForTeacherToFeedYouWithSomeNewInformation: "Wait for teacher to feed you with some new information",
	// createFeedPost: "Create feed post",
	// targetList: "Target list",
	beAmazing: 'Be amazing!',
	login: 'Login',
	getStarted: 'Get started',
	// enterYourSchoolEmail: "Enter your school email",
	password: 'Password',
	email: 'Email',
	requestNewPassword: 'Request new password',
	newPassword: 'New password',
	enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: "Enter your school email and we'll send you a link to get back into your account",
	sendRequest: 'Send request',
	verifyYourEmail: 'Verify your email',
	weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere: "We've sent you a link to get back into your account. Check your mail and copy your token here.", // TODO: Check does it need new line
	resendARequest: 'Resend a request',
	didntGetAMail: "Didn't get a mail?",
	submit: 'Submit',
	// enterYourNewPassword: "Enter your new password",
	// apply: "Apply",
	// howDoYouFeel: "How do you feel?",
	poll: 'Poll',
	// thereAreNoAnswersOrFeedbacksForThisDay: "There are no answers or feedbacks for this day",
	title: 'Title',
	message: 'Message',
	// requested: "Requested",
	anonymous: 'Anonymous',
	// url: "Url",
	// addPhoto: "Add Photo",
	// removePhoto: "Remove Photo",
	// youAreAllDone: "You are all done!",
	// congratsEverythingIsDoneForNowWaitForNewTasks: "Congrats, everything is done for now! Wait for new tasks...",
	//---- NEEDS ADDITIONAL CHECK(SOME SENTENCES MISSING, FEELINGS NOT COVERED)
	excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Excellent work! We’re delighted to hear things are so much better.',
	thisIsYourSafePlaceAndNothingWillBeShared: 'This is your safe place. Nothing will be shared.',
	enterANameForTodaysNotes: "Enter a name for today's notes.",
	iDontWantToSaveNotes: 'I don’t want to save notes',
	worse: 'Worse',
	sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow: 'Sorry to hear that things are worse. Which of the following would help right now?',
	sorryToHearThatThingsAreWorse: 'Sorry to hear that things are worse.', // WE HAVE: We’re sorry to hear that things aren’t great
	muchWorse: 'Much worse',
	feelingMuchWorseQuestion: 'Sorry to hear that things are much worse. Which of the following would help right now?',
	sorryToHearThatThingsAreMuchWorse: 'Sorry to hear that things are much worse.', // WE HAVE: We’re sorry to hear that things aren’t great.
	same: 'Same',
	feelingSameQuestion: 'What are some ideas to make things better?',
	better: 'Better',
	feelingBetterQuestion: 'Good to hear things are better. What are some ideas to take it even further?',
	goodToHearThingsAreBetter: 'Good to hear things are better.', // WE HAVE: We're hoping that you are going to feel better next time
	muchBetter: 'Much better',
	greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel: 'Great to hear things are much better. Think about how to improve even more or keep it on a positive level',
	//---- NEEDS ADDITIONAL CHECK
	suggestions: 'Suggestions',
	// ImOkWithIt: "I’m Ok with it",
	// IdPreferIfTheyWereBetter: "I’d prefer if they were better",
	loadMoreSuggestions: 'Load more suggestions',
	continue: 'Continue',
	deleteNote: 'Delete Note',
	today: 'Today',
	comparedToLastTimeTodayIamFeeling: "Compared to last time, today I'm feeling",
	howDoYouFeelComparedToLastTimeYouDidThePoll: 'How do you feel compared to last time you did the poll?',
	thisInformationWillBeSharedWith: 'This information will be shared with teacher.',
	feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Feel free to share any thoughts here why you feel this way',
	// feedback: "Feedback",
	// choose: "Choose",
	// newFeeds: "New feeds",
	openTasks: 'Open Tasks',
	// taskArchive: "Task Archive",
	// congratsAndEverythingIsDoneForNowAndWaitForNewTasksFromYourTeacher: "Congrats, everything is done for now! Wait for new tasks from your teacher",
	newConversation: 'New conversation',
	iCareAndIListenChat: 'I Care / I Listen Chat', // TODO
	teacher: 'Teacher',
	// teachers: "Teachers",
	counselor: 'Counselor',
	secretKey: 'Secret key',
	advancedSettings: 'Advanced settings',
	// showDailyReflectionScreen: "Show daily reflection screen",
	termsAndConditions: 'Terms & Conditions',
	// appVersion: "App version: ",
	surname: 'Surname',
	firstName: 'First Name',
	// gender: "Gender",
	// other: "Other",
	// thisIsYourSafePlace: "This is your safe place",
	thisIsYourPrivateRoom: 'This is your private room.',
	safePlaceWithDailyReflectionNotes: 'Safe place with daily reflection notes',
	personalInformation: 'Personal information',
	privacyAndSecurity: 'Privacy and security',
	// dashboard: "Dashboard",
	// update: "Update",
	// unselect: "Unselect",
	// noResults: "No results",
	open: 'Open',
	openLink: 'Open link',
	// share: "Share",
	// back: "Back",
	// task: "Task",
	tasks: 'Tasks',
	logout: 'Logout',
	save: 'Save',
	name: 'Name',
	profile: 'Profile',
	// classroom: "Classroom",
	feed: 'Feed',
	// live: "Live",
	Yes: 'Yes',
	No: 'No',
	archive: 'Archive',
	yesterday: 'Yesterday',
	tomorrow: 'Tomorrow',
	// results: "Results",
	// required: "Required",
	// schedule: "Schedule",
	happy: 'happy',
	ecstatic: 'ecstatic',
	inspired: 'inspired',
	calm: 'calm',
	lethargic: 'lethargic',
	grumpy: 'grumpy',
	sad: 'sad',
	stressed: 'stressed',
	angry: 'angry',
	Happy: 'happy',
	Ecstatic: 'ecstatic',
	Inspired: 'inspired',
	Calm: 'calm',
	Lethargic: 'lethargic',
	Grumpy: 'grumpy',
	Sad: 'sad',
	Stressed: 'stressed',
	Angry: 'angry',
	sunday: 'Sunday',
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	// scheduled: "Scheduled",
	delivered: 'Delivered',
	// first: "First",
	// second: "Second",
	// third: "Third",
	seen: 'Seen',
	// selectStaff: "Select staff",
	forgotPassword: 'Forgot password?',
	repeatPassword: 'Repeat password',
	retypePassword: 'Retype password',
	changePassword: 'Change password',
	// hidePassword: "Hide password",
	// dailyFeedback: "Daily Feedback",
	// createNew: "Create new",
	// selectionType: "Selection type",
	enterSurname: 'Enter surname',
	// enterEmail: "Enter email",
	newMessage: 'New message!',
	myTasks: 'My Tasks',
	// addOption: "Add option",
	// newQuestion: "New Question",
	// editQuestion: "Edit Question",
	// editPost: "Edit post",
	// editPoll: "Edit poll",
	// tomorrowPlans: "Tomorrow plans",
	// confirmStopping: "Confirm stopping",
	// newPoll: "New poll",
	// answer: "Answer",
	// post: "Post",
	hi: 'Hi',
	// stop: "Stop",
	// lastTime: "Last time",
	// suggestions: "Suggestions",
	// sendAnswer: "Send answer",
	comment: 'Comment',
	passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol: 'Password must be longer than 8 characters, must contains uppercase, lowercase, number and special symbol',
	enterYourWorkEmailAndPassword: 'Enter your work email and password',
	submitNewPassword: 'Submit new password',
	// pleaseCheckYourMailToConfirmYourEmailAddress: "Please check your mail to confirm your email address!",
	// howDoYouFeelAboutThingsBeingTheSameToday: "How do you feel about things being the same today?",
	// pollHasBeenUpdated: "Poll has been updated",
	// typeAPostTitle: "Type a post title",
	// addAnOptionalMessage: "Add an optional message",
	writeYourMessageHere: 'Write your message here',
	// enterUrlLink: "Enter url link",
	// saveAndContinue: "Save and continue",
	// nameOfTodayNote: "Name of today note",
	whatAreJust3GoodThingsThatHappenedToday: 'What are just 3 good things that happened today?',
	// yourDirectManager: "your direct manager",
	secretKeyHasBeenSaved: 'Secret key has been saved',
	// enterYourSecretKeyToEncryptLllYourMessagesAndAnswers: "Enter your secret key to encrypt all your messages and answers",
	enterSecretKey: 'Enter secret key',
	// advancedSettingsAreSuccessfullySaved: "Advanced settings are successfully saved!",
	// youCanUseTheButtonsAboveToContactYourTeacherOrCounselorForSupportAtAnyPoint: "You can use the buttons above to contact your teacher or counselor for support at any point",
	// waitForStudentsToContactYouToHelpThem: "Wait for students to contact you to help them",
	passwordsDoNotMatch: 'Passwords do not match',
	// startNewChat: "Start new chat",
	// shareWithTeacher: "Share with teacher",
	// tasksForThisSection: "Tasks for this section",
	// howWasYourDay: "How was your day?",
	// thisIsAutoReplyMessage: "This is auto reply message",
	thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices: 'Thank you for reaching out. We will reply to your message soon.\n If you, or someone you know is in immediate danger please call emergency services.',
	doYouThinkThingsAreForAnyReasonInParticular: 'Do you think things are {{result}} for any reason in particular',
	yourPrivateNotes: 'Your private notes',
	// createNewPoll: "Create new poll",
	// saveAsTemplate: "Save as template",
	// addPostContentHere: "Add post content here",
	// typeAPollQuestion: "Type a poll question",
	// questionHasBeenUpdated: "Question has been updated",
	// questionHasBeenPosted: "Question has been posted",
	iDontWantToThinkAboutThisNow: "I don't want to think about this now",
	selectLanguage: 'Select language1',
	userIsUpdated: 'User is updated',
	// imageIsNotUploaded: 'Image is not uploaded',
	// feedHasBeenUpdated:'Feed has been updated',
	// permissionIsNotAccepted:'Permission is not accepted',
	// feedHasBeenPosted: 'Feed has been posted',
	// pollHasBeenPosted:'Poll has been posted',
	// templateHasBeenSaved: 'Template has been saved',
	privateNoteHasBeenSaved: 'Private note has been saved',
	// yourEmotionHasBeenShared: 'Your emotion has been shared',
	writePersonalNotesHere: 'Write your personal notes here (only you can see this)',
	compareToLastTime: 'Compare to last time',
	yourAnswerIsSaved: 'Your answer is saved',
	staySecuredFirst: 'Stay secured first',
	Surveys: 'Surveys',
	survey: 'survey',
	Section: 'Section',
	Sections: 'Sections',
	youHaveNoChats: 'You have no chats',
	sos: 'SOS',
	open_survey: 'Open survey',
	anonymous_survey: 'Anonymous survey',
	'Take it': 'Take it',

	//-------------------------------------------------------------------------------------------------------------------------
	confirmDeletion: 'تأكيد الحذف',
	deleteTheTemplateFor: 'احذف القالب الخاص بـي',
	cancel: 'إلغاء',
	delete: 'حذف',
	createContent: 'إنشاء المحتوى',
	askAQuestion: 'اسأل سؤال',
	createAPoll: 'إنشاء استطلاع',
	createAPost: 'أنشئ منشورًا',
	orChooseFromTemplatesBelow: 'أو اختر من القوالب أدناه',
	on: 'على',
	off: 'أبداً',
	never: 'أبداً',
	chooseTemplate: 'اختيار القالب',
	thereAreNoTemplatesCreated: ' لا توجد قوالب تم إنشاؤها',
	howAreYouToday: 'كيف حالك اليوم؟',
	selectEmotion: 'اختار العاطفة',
	question: 'سؤال',
	genderSelection: 'اختيار الجنس',
	all: 'الكل',
	male: 'ذكر',
	female: 'أنثى',
	settings: 'إعدادات',
	support: 'دعم',
	privacyPolicy: 'سياسة الخصوصية',
	about: 'عن',
	dayReview: 'مراجعة اليوم',
	dailyReflection: 'تفكير يومي',
	youLiked: 'انت أعجبك',
	like: 'اعجب',
	edit: 'تعديل',
	answered: 'أجاب',
	showLess: 'اظهار أقل',
	showMore: 'أظهر المزيد',
	search: 'بحث',
	targetGroup: 'المجموعة المستهدفة',
	quickAction: 'عمل سريع',
	select: 'اختار ',
	selectByGroup: 'اختر بالمجموعة',
	selectSchoolYearsThatYouLikeToTarget: 'حدد سنوات الدراسة التي ترغب في استهدافها',
	years: 'سنوات',
	selectClassesThatYouLikeToTarget: 'حدد الفئات التي ترغب في استهدافها',
	classes: 'فئات',
	selectACustomListThatYouLikeToTarget: 'حدد قائمة مخصصة ترغب في استهدافها',
	custom: 'مخصصة',
	selectTeachersYouWouldLikeToTarget: 'حدد المعلمين الذين ترغب في استهدافهم',
	staff: 'العاملين',
	year: 'Year',
	class: 'Class',
	'Multiple years': 'عدة سنوات',
	'Multiple classes': 'فصول متعددة',
	selectYears: 'اختار السنوات',
	selectClasses: 'اختار الفئات',
	selectFromMyStudents: 'اختر من طلابي',
	multipleClasses: 'فصول متعددة',
	multipleYears: 'عدة سنوات',
	allStudents: 'كل الطلاب',
	done: 'تم',
	waitForTeachersToFeedYouWithSomeNewInformations: 'انتظر حتى يقوم المعلمون بإخبارك ببعض المعلومات الجديدة',
	feedIsEmpty: 'البث فارغ',
	thereIsNoFeedForThisSearch: 'لا توجد بث لهذا البحث',
	createNewPostsForYourStudentsAndHereIsAShortcutForYou: 'إنشاء مشاركات جديدة لطلابك. هنا اختصار لك.',
	waitForTeacherToFeedYouWithSomeNewInformation: 'انتظر حتى يقوم المعلمون بإخبارك ببعض المعلومات الجديدة',
	createFeedPost: 'انشاء منشورًا',
	targetList: 'قائمة الهدف',
	beAmazing: 'كن رائعا!',
	login: 'تسجيل الدخول',
	getStarted: 'البدء',
	enterYourSchoolEmail: 'أدخل البريد الإلكتروني لمدرستك',
	password: 'كلمة المرور',
	email: 'البريد الإلكتروني',
	requestNewPassword: 'طلب كلمة مرور جديدة',
	newPassword: 'كلمة السر الجديدة',
	enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: 'أدخل البريد الإلكتروني لمدرستك وسنرسل لك رابطًا للعودةفي حسابك',
	sendRequest: 'ارسل طلب',
	verifyYourEmail: 'قم بتأكيد بريدك الألكتروني',
	weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere: 'لقد أرسلنا لك رابطًا للعودة إلى حسابك. تحقق من بريدك وانسخ رمزك هنا.',
	resendARequest: 'إعادة إرسال طلب',
	didntGetAMail: 'ألم تصلك بريدًا؟',
	submit: 'قدم',
	enterYourNewPassword: 'أدخل كلمة المرور الجديدة',
	apply: 'طبق',
	howDoYouFeel: 'ما هو شعورك؟',
	poll: 'استطلاع',
	thereAreNoAnswersOrFeedbacksForThisDay: 'لا توجد إجابات أو ردود فعل لهذا اليوم',
	title: 'عنوان',
	message: 'رسالة',
	'addPhoto/Video': 'Foto hinzufügen',
	remove: 'Löschen',
	requested: 'المطلوب',
	anonymous: 'مجهول',
	url: 'عنوان Url',
	addPhoto: 'إضافة صورة',
	removePhoto: 'إزالة الصورة',
	youAreAllDone: 'لقد انتهيت!',
	congratsEverythingIsDoneForNowWaitForNewTasks: 'تهانينا ، تم إنجاز كل شيء الآن! انتظر المهام الجديدة ...',
	excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'عمل ممتاز! يسعدنا أن نسمع أن الأمور أفضل بكثير.',
	thisIsYourSafePlaceAndNothingWillBeShared: 'هذا هو مكانك الآمن. لن يتم مشاركة أي شيء.',
	enterANameForTodaysNotes: 'أدخل اسمًا لملاحظات اليوم.',
	iDontWantToSaveNotes: 'لا أريد حفظ الملاحظات',
	worse: 'أسوأ بكثير',
	sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow: 'آسف لسماع أن الأمور أسوأ. أي مما يلي قد يساعدك الآن؟',
	muchWorse: 'أسوأ بكثير',
	sorryToHearThatThingsAreMuchWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
	sorryToHearThatThingsAreWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
	sorryToHearThatThingsAreMuchWorseAndWhichOfTheFollowingWouldHelpRightNow: 'آسف لسماع أن الأمور أسوأ بكثير. أي مما يلي قد يساعدك الآن؟',
	same: 'نفس',
	whatAreSomeIdeasToMakeThingsBetter: 'ما هي بعض الأفكار لتحسين الأمور؟',
	better: 'أفضل',
	goodToHearThingsAreBetterAndWhatAreSomeIdeasToTakeItEvenFurther: 'من الجيد سماع الأشياء أفضل. ما هي بعض الأفكار التي يجب أن نأخذها إلى أبعد من ذلك ؟ ',
	goodToHearThingsAreBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
	greatToHearThingsAreMuchBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
	muchBetter: 'أفضل بكثير',
	greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel: 'من الرائع سماع الأشياء أفضل بكثير. فكر في كيفية تحسينها أكثر أو الحفاظ عليها في مستوى إيجابي ',
	suggestions: 'اقتراحات',
	ImOkWithIt: 'أنا بخير معها',
	IdPreferIfTheyWereBetter: 'كنت أفضل إذا كان أفضل',
	loadMoreSuggestions: 'تحميل المزيد من الاقتراحات',
	continue: 'استمر',
	deleteNote: 'احذف الملاحظة',
	today: 'اليوم',
	comparedToLastTimeTodayIamFeeling: 'بالمقارنة مع آخر مرة ، أشعر اليوم ',
	howDoYouFeelComparedToLastTimeYouDidThePoll: 'ما هو شعورك مقارنة بآخر مرة أجريت فيها الاستطلاع؟',
	thisInformationWillBeSharedWith: 'سيتم مشاركة هذه المعلومات مع المعلم.',
	feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'لا تتردد في مشاركة أي أفكار هنا عن سبب شعورك بهذه الطريقة',
	feedback: 'استجابة',
	choose: 'اختار',
	newFeeds: 'بث جديد',
	openTasks: 'فتح المهام',
	taskArchive: 'أرشيف المهام',
	congratsAndEverythingIsDoneForNowAndWaitForNewTasksFromYourTeacher: 'تهانينا ، تم إنجاز كل شيء الآن! انتظر المهام الجديدة من معلمك',
	newConversation: 'محادثة جديدة',
	iCareAndIListenChat: 'أنا أهتم / أستمع للمحادثة',
	'I Care / I Listen': 'SOS',
	teachers: 'Teachers',
	teacher: 'معلم',
	counselor: 'مستشار',
	Counselor: 'مستشار',
	secretKey: 'زر سري',
	advancedSettings: 'إعدادات متقدمة',
	showDailyReflectionScreen: 'إظهار شاشة الراجعة اليومي',
	termsAndConditions: 'الشروط والأحكام',
	appVersion: 'نسخة التطبيق:',
	surname: 'اسم العائلة',
	firstName: 'السم الأول',
	gender: 'جنس',
	other: 'اخر',
	thisIsYourSafePlace: 'هذا هو مكانك الآمن',
	thisIsYourPrivateRoom: 'هذه غرفتك الخاصة.',
	safePlaceWithDailyReflectionNotes: 'مكان آمن مع ملاحظات المراجعة يومية',
	personalInformation: 'معلومات شخصية',
	privacyAndSecurity: 'الخصوصية والأمن',
	dashboard: 'أداة متابعة',
	update: 'تحديث',
	unselect: 'Auswahl aufheben',
	noResults: 'Keine Ergebnisse',
	open: 'Nicht-anonyme',
	share: 'mit dem Lehrer teilen',
	back: 'Zurück',
	task: 'Aufgabe',
	tasks: 'Aufgaben',
	logout: 'Ausloggen',
	save: 'Speichern',
	name: 'Name',
	profile: 'Profil',
	classroom: 'Klassenzimmer',
	feed: 'Feed',

	live: 'Live',
	archive: 'Archiv',
	yesterday: 'في الامس',
	tomorrow: 'Morgen',
	results: 'Ergebnisse',
	required: 'Erforderlich',
	schedule: 'Zeitplan',
	happy: 'glücklich',
	ecstatic: 'begeistert',
	inspired: 'inspiriert',
	calm: 'ruhig',
	lethargic: 'träge',
	grumpy: 'verärgert',
	sad: 'traurig',
	stressed: 'gestresst',
	angry: 'wütend',
	sunday: 'Sonntag',
	monday: 'Montag',
	tuesday: 'Dienstag',
	wednesday: 'Mittwoch',
	thursday: 'Donnerstag',
	friday: 'Freitag',
	saturday: 'Samstag',
	scheduled: 'Geplant',
	delivered: 'Geliefert',
	first: 'Zuerst',
	second: 'Zweite',
	third: 'Dritte',
	seen: 'Gesehn',
	forgotPassword: 'Passwort vergessen?',
	retypePassword: 'Passwort erneut eingeben',
	selectStaff: 'اختار الموظفين',
	repeatPassword: 'اعد كلمة السر',
	changePassword: 'غير كلمة السر',
	hidePassword: 'اخفاء كلمة المرور',
	dailyFeedback: 'ردود الفعل اليومية',
	enterSurname: 'أدخل اللقب',
	enterEmail: 'أدخل البريد الإلكتروني',
	newMessage: 'رسالة جديدة',
	addOption: 'إضافة خيار',
	createNew: 'Neue',
	selectionType: 'Auswahl',
	myTasks: 'Meine Aufgaben',
	newQuestion: 'Neue Frage',
	editQuestion: 'Frage bearbeiten',
	editPost: 'Beitrag bearbeiten',
	editPoll: 'Umfrage bearbeiten',
	tomorrowPlans: 'Morgen Pläne',
	confirmStopping: 'Bestätigen Sie das Anhalten',
	newPoll: 'Neue Umfrage',
	answer: 'Antworten',
	post: 'Post',
	hi: 'Hallo',

	stop: 'Halt',
	lastTime: 'Letztes Mal',
	sendAnswer: 'Antwort senden',
	comment: 'تعليق',
	passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol: 'يجب أن تكون كلمة المرور أطول من ٨ أحرف ، ويجب أن تحتوي على أحرف كبيرة وصغيرة ورقم ورمز خاص',
	enterYourWorkEmailAndPassword: 'أدخل البريد الإلكتروني الخاص بالعمل وكلمة المرور',
	submitNewPassword: 'إرسال كلمة المرور الجديدة',
	pleaseCheckYourMailToConfirmYourEmailAddress: 'يرجى التحقق من بريدك لتأكيد عنوان بريدك الإلكتروني!',
	howDoYouFeelAboutThingsBeingTheSameToday: 'ما هو شعورك بآن الأشياء هي نفسها اليوم؟',
	pollHasBeenUpdated: 'تم تحديث الاستطلاع',
	typeAPostTitle: 'اكتب عنوان المنشور',
	addAnOptionalMessage: 'أضف رسالة اختيارية',
	writeYourMessageHere: 'اكتب رسالتك هنا',
	enterUrlLink: 'أدخل رابط URL',
	saveAndContinue: 'احفظ وتابع',
	nameOfTodayNote: 'اسم مذكرة اليوم',
	whatAreJust3GoodThingsThatHappenedToday: 'ما هي أشياء ثلاثة جيدة التي حدثت اليوم؟',
	yourDirectManager: 'مديرك المباشر',
	secretKeyHasBeenSaved: 'تم حفظ المفتاح السري',
	enterYourSecretKeyToEncryptLllYourMessagesAndAnswers: 'أدخل مفتاحك السري لتشفير جميع رسائلك وإجاباتك',
	enterSecretKey: 'أدخل مفتاح السر',
	advancedSettingsAreSuccessfullySaved: 'تم حفظ الإعدادات المتقدمة بنجاح!',
	youCanUseTheButtonsAboveToContactYourTeacherOrCounselorForSupportAtAnyPoint: 'يمكنك استخدام الأزرار أعلاه للاتصال بمعلمك أو مرشدك للحصول على الدعم في أي وقت',
	waitForStudentsToContactYouToHelpThem: 'انتظر حتى يتصل بك الطلاب لمساعدتهم',
	passwordsDoNotMatch: 'كلمة المرور غير مطابقة',
	startNewChat: 'ابدأ محادثة جديدة',
	shareWithTeacher: 'شارك مع المعلم',
	tasksForThisSection: 'Aufgaben in diesem Bereich',
	howWasYourDay: 'كيف كان يومك؟',
	thisIsAutoReplyMessage: 'هذه رسالة رد تلقائي',
	thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices: 'شكرا لك على التواصل. سوف نقوم بالرد على رسالتك قريبا. إذا كنت أنت أو أي شخص تعرفه في خطر ، يرجى الاتصال بخدمات الطوارئ.',
	doYouThinkThingsAreForAnyReasonInParticular: 'هل تعتقد أن الأمور {{result}} لأي سبب محدد؟',
	yourPrivateNotes: 'ملاحظاتك الخاصة',
	createNewPoll: 'إنشاء استطلاع جديد',
	saveAsTemplate: 'حفظ كقالب',
	addPostContentHere: 'أضف محتوى آخر هنا',
	typeAPollQuestion: 'اكتب سؤال استطلاع',
	questionHasBeenUpdated: 'اكتب سؤال استطلاع',
	questionHasBeenPosted: 'تم نشر السؤال',
	iDontWantToThinkAboutThisNow: 'لا أريد أن أفكر في هذا الآن',

	selectLanguage: 'Sprache auswählen',
	userIsUpdated: 'Benutzer ist aktualisiert',
	imageIsNotUploaded: 'Bild ist nicht hochgeladen',
	feedHasBeenUpdated: 'Feed wurde aktualisiert',
	permissionIsNotAccepted: 'Erlaubnis ist nicht akzeptiert',
	feedHasBeenPosted: 'Feed wurde veröffentlicht',
	pollHasBeenPosted: 'Umfrage wurde veröffentlicht',
	templateHasBeenSaved: 'Vorlage wurde gespeichert',
	privateNoteHasBeenSaved: 'Private Notiz wurde gespeichert',
	yourEmotionHasBeenShared: 'deine Antwort wurde geteilt',
	writePersonalNotesHere: 'Schreiben Sie hier Ihre persönlichen Notizen (nur Sie können diese sehen)',
	compareToLastTime: 'Vergleiche mit dem letzten Mal',
	yourAnswerIsSaved: 'Ihre Antwort ist gespeichert',
	staySecuredFirst: 'Sicherheit geht vor',
	'You have no live content': 'Es gibt noch keine Inhalte',
	'Create something and see the results live!': 'Mache hier Inhalte und bekomme live feedback!',
	'Creation shortcuts for you': 'Hier kannst du Inhalte machen',
	'You have no chats': 'Du hast noch keine Chats',
	'Type a question': 'Hier Frage eingeben',
	anonymousQuestion: 'Anonyme Frage',
	openQuestion: 'Nicht-anonyme Frage',
	open_poll: 'Nicht-anonyme Frage',
	open_survey: 'Nicht-anonyme Frage',
	anonymous_survey: 'Anonyme Umfrage',
	anonymous_poll: 'Anonyme Umfrage',
	'Pick one option': 'Nur eine Antwort erlauben',
	'Allow more than one answer': 'Mehr als eine Antwort erlauben',
	solutions: 'Solutions',
	sos: 'SOS',

	'copy message': 'نسخ الرسالة',
	"List of students who haven't logged in yet and it’s ": 'قائمة الطلاب الذين لم يسجلوا الدخول بعد وهي موجودة',
	'Students login data': 'بيانات تسجيل دخول الطلاب',
	'Select from favorites': 'اختر من المفضل',
	Favorite: 'المفضل',
	'Select your favorite group': 'حدد مجموعتك المفضلة',
	Solutions: 'حلول',
	Update: 'تحديث',
	'New Version is Available': 'الإصدار الجديد متاح',
	'Delete this note?': 'حذف هذه الملاحظة؟',
	'Stop tracking live results for title': 'توقف عن تتبع النتائج المباشرة لـ',
	'Delete this favorite group?': 'هل تريد حذف هذه المجموعة المفضلة؟',
	'Do not agree': 'لا توافق',
	"If you don't agree to Terms and Conditions or Privacy Policy you are not going to be allowed to use the app!": 'إذا كنت لا توافق على الشروط والأحكام أو سياسة الخصوصية ، فلن يُسمح لك باستخدام التطبيق!',
	'You will be logged out': 'سوف يتم تسجيل خروجك',
	'Delete this feed?': 'هل تريد حذف هذا البث؟',
	'Delete the template for title': 'احذف القالب الخاص بـ',
	'No one yet': 'لا أحد حتى الآن',
	'Seen by:': 'تمت رؤيته بواسطة:',
	Copied: 'نسخ',
	'Action taken': 'تم اتخاذ فعل',
	'Write your thoughts here': 'اكتب أفكارك هنا',
	'Describe how will you take action about this student': 'صف كيف ستتخذ إجراءً بشأن هذا الطالب',
	'I will take action': 'سوف أتخذ إجراء',
	'Ask your manager to assign you to class.': 'اطلب من مديرك أن يعينك للفصل.',
	'You have no data about your classroom': 'ليس لديك بيانات عن فصلك الدراسي',
	'Terms and Conditions and Privacy Policy': 'الشروط والأحكام وسياسة الخصوصية',
	"I confirm that I read and agree to Upstrive's": 'أؤكد أنني قرأت وأوافق على ابسترايف',
	'Terms and Conditions': 'الأحكام والشروط',
	'Privacy Policy': 'سياسة الخصوصية',
	'I do not agree': 'انا لا اوافق',
	'New survey!': 'استقصاء جديد!',
	'You have a survey from name about': 'لديك {{name}}استقصاء من اسم عن ...',
	voluntary: 'اختياري',
	mandatory: 'إلزامي',
	'Your counseling list is empty, start with adding a new counseling profile for one of your students': 'قائمة الاستشارات الخاصة بك فارغة ، ابدأ بإضافة ملف تعريف استشاري جديد لأحد طلابك',
	'Reminder for today': 'تذكير لهذا اليوم',
	'Track Counseling': 'مسار الاستشارة',
	'Congrats, everything is done for now!': 'تهانينا ، تم إنجاز كل شيء الآن!',
	'Wait for new tasks...': 'انتظر المهام الجديدة ...',
	'Manage running programs': 'إدارة البرامج قيد التشغيل',
	'This tool helps you to control all running programs and track their influence to students': 'تساعدك هذه الأداة في التحكم في جميع البرامج قيد التشغيل وتتبع تأثيرها على الطلاب',
	'Your running program list is empty, start by adding one from the list of programs': 'قائمة البرامج قيد التشغيل فارغة ، ابدأ بإضافة واحدة من قائمة البرامج',
	'Run program': 'نفذ البرنامج',
	"This tool helps you to schedule whole program once so you don't need to check it all the time": 'تساعدك هذه الأداة في جدولة البرنامج بالكامل مرة واحدة حتى لا تحتاج إلى التحقق منه طوال الوقت',
	'Target group:': 'المجموعة المستهدفة:',
	'Start date:': 'تاريخ البدء',
	'Select days:': 'حدد الأيام',
	'Pick time:': 'اختر وقت',
	'Current programs:': 'البرامج الحالية',
	Running: 'ادارة',
	'Show more programs': 'عرض المزيد من البرامج',
	Surveys: 'الدراسات الاستقصائية',
	'Choose from our range of ready-to-go programs designed to support your students and save you times now': 'اختر من بين مجموعة البرامج الجاهزة للاستخدام المصممة لدعم طلابك وتوفير الوقت لك الآن',
	'Create a survey': 'قم بإنشاء دراسات استقصائية',
	'Type a survey title': 'اكتب عنوان الدراسات الاستقصائية',
	'add a survey description': 'أضف وصف الدراسات الاستقصائية',
	'enter a section title here': 'أدخل عنوان الجزء هنا ....',
	Section: 'الجزء',
	Sections: 'Abschnitte',
	'enter a section description here': 'أدخل وصف القسم هنا',
	'Enter a question here': 'أدخل سؤالا هنا',
	'Add section': 'إضاف جزء',
	'Delete survey': 'حذف استقصاء',
	'Save Survey': 'Umfrage speichern',
	'Edit Survey': ' تعديل استقصاء',
	'This tool helps you to run a survey for your students': 'تساعدك هذه الأداة في إجراء استقصاء لطلابك',
	'Configure survey': 'تكوين الستقصاء',
	'Easily manage your students and teachers, using separate functions': 'قم بإدارة الطلاب والمعلمين بسهولة باستخدام وظائف منفصلة',
	'Login info': 'معلومات تسجيل الدخول',
	'Class info': 'معلومات الفصل',
	Favorite: 'مفضل',
	Download: 'تحميل',
	'Export report': 'تقرير التصدير',
	'Enter your note here': 'أدخل ملاحظتك هنا',
	'Add reminder': 'إضافة تذكير',
	'Show more surveys': 'عرض المزيد من الستقصاء',
	'Open survey results': 'فتح نتائج الستقصاء',
	'Take it now': 'خذه الان',
	'Take it later': 'خذها لاحقًا',
	Category: 'فئة',
	'Select all': 'Wählen Sie Alle',
	'Survey results': 'Umfrageergebnisse',
	'We hope you’ve had a good day!': 'Wir hoffen, Sie hatten einen schönen Tag!',
	'Save your favorite group': 'Speichern Sie Ihre Lieblingsgruppe',
	'Take it': 'Ergänze',
	Answered: 'أجاب',
	Poll: 'استطلاع',
	'Advanced settings are successfully saved!': 'تم حفظ الإعدادات المتقدمة بنجاح!',

	'At least 8 characters': 'At least 8 character',
	chat: 'دردشة',
	'Start chat': 'Start chat',
	'Language is changes!': 'Language is changes!',
	'Wellbeing tracker': 'Wellbeing tracker',
	'Your list is empty': 'Your list is empty',
	'You can press yellow button and create a new Wellbeing profile': 'You can press yellow button and create a new Wellbeing profile',
	'My users': 'My users',
	'All users': 'All users',
	'Create wellbeing profile': 'Create wellbeing profile',
	'You have no data about you classroom': 'You have no data about you classroom',
	'Ask you manager to assign you to class': 'Ask you manager to assign you to class',
	'There is no feed for this search': 'There is no feed for this search',
	'Try searching for something else': 'Try searching for something else',
	open_journal: 'Open journal',
	'What are 3 things that are a bit challenging at the moment?': 'What are 3 things that are a bit challenging at the moment?',
	'What’s just one thing you will do differently tomorrow?': 'What’s just one thing you will do differently tomorrow?',
	'This is your safe place Nothing will be shared': 'This is your safe place. Nothing will be shared.',
	'You are not in charge of this student so your messages will be forwarded to school admin or counselor': 'You are not in charge of this student so your messages will be forwarded to school admin or counselor',
	'You are not allowed to create content': 'You are not allowed to create content',
	'Add to Wellbeing tracker': 'Add to Wellbeing tracker',
	'Your {type} list is empty': 'Your {type} list is empty',
	'Enter name': 'Enter name',
	'There are no templates created': 'There are no templates created',
	'There is not any survey created': 'There is not any survey created',
	'Run it': 'Run it',
	'No emotion': 'No emotion',
	Tasks: 'Tasks',
	Survey: 'Survey',
	'Take survey': 'Take survey',
	'Select one option': 'Select one option',
	'You have missed this question': 'You have missed this question',
	'You have missed some questions': 'You have missed some questions',
	Finish: 'Finish',
	'Next section': 'Next section',
	'There is an error': 'There is an error',

	'Media is not uploaded': 'Media is not uploaded',
	'Permission is not accepted': 'Permission is not accepted',
	'Post has been updated': 'Post has been updated',
	'Post has been posted': 'Post has been posted',
	'Image is not uploaded': 'Image is not uploaded',
	'Survey is created': 'Survey is created',
	'Something went wrong': 'Something went wrong',
	'Private note has been saved!': 'Private note has been saved!',
	'Your results are saved!': 'Your results are saved!',
	'Write full answer here': 'Write full answer here',
	'If message is hidden, only admins and conselors will be able to read it': 'If message is hidden, only admins and conselors will be able to read it',
	'Do you want to hide a message?': 'Do you want to hide a message?',
	'Do you want to unhide a message?': 'Do you want to unhide a message?',
	Unhide: 'Unhide',
	Hide: 'Hide',
	'Selection type': 'Selection type',

	'Need some help?': 'Need some help?',
	'I have an issue related to': 'I have an issue related to',
	'Sorry, your school restricted access to this module': 'Sorry, your school restricted access to this module',
	Myself: 'Myself',
	Friends: 'Friends',
	Family: 'Family',
	School: 'School',
	'Explore things you can do right now': 'Explore things you can do right now',
	'See how other students handle this': 'See how other students handle this',
	'Connect with the Counselor': 'Connect with the Counselor',
	'Quick tips': 'Quick tips',
	'Things you can do right now': 'Things you can do right now',
	'See how other students handle this': 'See how other students handle this',
	'Connect with the Counselor': 'Connect with the Counselor',
	Topic: 'Topic',
	'Send Message': 'Send Message',
	'How to deal with this problem:': 'How to deal with this problem:',
	'Was this solution helpful?': 'Was this solution helpful?',
	'Yes, thanks!': 'Yes, thanks!',
	'Not really!': 'Not really!',

	Attention: 'Attention',
	toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey: 'To ensure your privacy, this key is not recoverable. All your notes will be lost if you forget this key!',
	anonymousPoll: 'Anonymous Poll',
	Previous: 'Previous',

	'Dumo Points': 'Dumo Points',
	point: 'point',
	points: 'points',
	Point: 'Point',
	Points: 'Points',
};

export default TRANSLATION_AR;
